import {
  getApiUserManagementV1Notifications,
  patchApiUserManagementV1NotificationsIdRead,
  postApiUserManagementV1NotificationsClearAll,
  postApiUserManagementV1NotificationsIdDismiss,
  postApiUserManagementV1NotificationsIdRead
} from '@/libs/api-user-mgt/generated/notifications/notifications';

import { mapUmNotificationDtoToInApp, type UmNotificationsListDto } from '@/userManagement/application/mappers/mapUmNotificationDtoToInApp';
import type { UmInAppNotification } from '@/userManagement/domain/entities/UmHeaderContext';

export interface UmNotificationsResponse {
  notifications: UmInAppNotification[];
  totalCount: number;
  unreadCount: number;
}

export const userManagementContextSegment = {
  getNotifications: async (): Promise<UmNotificationsResponse> => {
    const r = await getApiUserManagementV1Notifications({ unreadOnly: false });
    const payload = (r.data ?? {}) as UmNotificationsListDto;
    const notifications = (payload.notifications ?? []).map(mapUmNotificationDtoToInApp);
    return {
      notifications,
      totalCount: payload.totalCount ?? notifications.length,
      unreadCount: payload.unreadCount ?? notifications.filter((n) => !n.isRead).length
    };
  },

  dismissNotification: async (id: number): Promise<{ ok: boolean }> => {
    await postApiUserManagementV1NotificationsIdDismiss(id);
    return { ok: true };
  },

  clearAllNotifications: async (): Promise<{ ok: boolean }> => {
    await postApiUserManagementV1NotificationsClearAll();
    return { ok: true };
  },

  markNotificationRead: async (id: number): Promise<{ ok: boolean }> => {
    await postApiUserManagementV1NotificationsIdRead(id);
    return { ok: true };
  },

  /** @deprecated Use markNotificationRead — kept for legacy PATCH during transition. */
  markNotificationReadPatch: async (id: number): Promise<{ ok: boolean }> => {
    await patchApiUserManagementV1NotificationsIdRead(id);
    return { ok: true };
  }
};
